import React, { useEffect } from "react";
import { naira } from "../../../utils/data";
import { ICON_EYE_FILL } from "../../../utils/icons";
import { useNavigate } from "react-router-dom";
import { useSalesContext } from "../../../context/sales_context";
import CustomTable from "../../../utils/CustomTable";

export default function AllInvoice() {

      const navigate = useNavigate();

      const {
            allSalesLoading, allSales, getAllSalesData,
      } = useSalesContext();

      useEffect(() => {
            const invoice = allSales?.map(({ invid, customer_name, total_amount_th, customer_phone, sales_date, status }, i) => {
                  return (
                        {
                              sn: 1 + i,
                              invid,
                              status,
                              customer_name: customer_name || 'Nil',
                              customer_phone: customer_phone || 'Nil',
                              total_amount_th: naira + total_amount_th,
                              sales_date,
                              action:
                                    <a className="d-flex fit-content  border-bottom pointer border-primary pry-text h6"
                                          onClick={() => navigateSalesItems(invid)}
                                    >
                                          {ICON_EYE_FILL} View </a>

                        }
                  );
            });

            setDatatable({
                  ...datatable,
                  rows:
                        invoice
            });
      }, [allSales]);

      useEffect(() => {
            getAllSalesData();
      }, []);

      const navigateSalesItems = (invid) => {
            const obj = { invid };
            navigate({
                  pathname: `${ invid }`,
                  state: obj,
            });
      };


      const [datatable, setDatatable] = React.useState({
            columns: [
                  {
                        label: "S/N",
                        field: "sn",
                        width: 150,
                        attributes: {
                              "aria-controls": "DataTable",
                              "aria-label": "Id",
                        },
                  },
                  {
                        label: "ID",
                        field: "invid",
                  },
                  {
                        label: "Date Added",
                        field: "sales_date",
                        width: 200,
                  },
                  {
                        label: "Name",
                        field: "customer_name",
                        width: 270,
                  },
                  {
                        label: "Phone",
                        field: "customer_phone",
                        width: 270,
                  },
                  {
                        label: "Payment",
                        field: "status",
                        width: 270,
                  },
                  {
                        label: "Amount",
                        field: "total_amount_th",
                        width: 270,
                  },
                  {
                        label: "View",
                        field: "action",
                        width: 200,
                  },

            ],
            rows: []
      });


      return (
            <>

                  <div className="">

                        <CustomTable
                              tableTitle={"All Invoice"}
                              loading={allSalesLoading}
                              getData={getAllSalesData}
                              datatable={datatable}
                        />

                  </div>

            </>

      );
}
